export default __webpack_public_path__ + "static/media/CatherineJohnson.137ac8fc.jpg";